import { Injectable, signal } from '@angular/core';

/**
 * Open/close state for the full-screen home-hub overlay. The trigger lives in
 * the sidebar header while the overlay itself renders at the app root (so it
 * sits above the sidebar drawer) — this service bridges the two.
 */
@Injectable({ providedIn: 'root' })
export class HomeHubOverlayService {
  readonly open = signal(false);

  show(): void {
    this.open.set(true);
  }

  hide(): void {
    this.open.set(false);
  }
}
